module.exports = __webpack_public_path__ + "components/panel/static/affiliate_snow-forecast-insurance-078c846998a3f9fcc63467d39733feaf.webp";